import { Components, Theme } from "@mui/material/styles";
import { getMenuTokens } from "./styles";

export const MuiMenuItem: Components<Theme>["MuiMenuItem"] = {
    styleOverrides: {
        root: ({ theme }) => {
            const { item } = getMenuTokens(theme);

            return {
                paddingTop: item.paddingTop,
                paddingBottom: item.paddingBottom,
                paddingLeft: item.paddingLeft,
                paddingRight: item.paddingRight,
                minHeight: item.minHeight,
                fontSize: item.fontSize,
                transitionProperty: item.transitionProperty,
                transitionDuration: item.transitionDuration,
                transitionTimingFunction: item.transitionTimingFunction,
                [theme.breakpoints.up("sm")]: {
                    minHeight: item.minHeight,
                },
                "&:hover": {
                    backgroundColor: item.focusBackgroundColor,
                },
                "&:active": {
                    backgroundColor: item.activeBackgroundColor,
                },
                "&.Mui-focusVisible": {
                    backgroundColor: item.focusBackgroundColor,
                },
                "&.Mui-selected.Mui-focusVisible": {
                    backgroundColor: item.focusBackgroundColor,
                },
                "&.Mui-expanded": {
                    backgroundColor: item.expandedBackgroundColor,
                },
                "&.Mui-disabled": {
                    opacity: item.disabledOpacity,
                    cursor: item.disabledCursor,
                },
            };
        },
    },
};
